module.exports = __webpack_public_path__ + "img/about-left.372e4117.png";